import React from 'react'
import { message } from 'antd'
import Button from 'meinian-package/src/baseComponent/button'
import SampleDetailExamine from 'component/imageDetail/sampleDetailCommon/sampleDetailExamine'
import { isPermissions } from 'meinian-package/src/utils/auth'
import { STYLE_PLAN } from 'common/config/enum'
import { SAMPLE_STATE } from 'common/config/sample.enum'
import { MEMBER_TYPE } from 'meinian-package/src/component/enum'
import userInfo from 'meinian-package/src/common/userInfo'
import request from 'meinian-package/src/utils/request'
import styles from './index.module.less'

const SAMPLE_OPERATION = {
  BEGIN_PATTERN: 1,
  MADE_PATTERN: 2,
  CANCEL_PATTERN: 3,
  BEGIN_SAMPLE: 4,
  MADE_SAMPLE: 5,
  CANCEL_SAMPLE: 6,
  PUECHASE_SAMPLE: 7,
  PURCHASED: 8,
  CANCEL_PURCHASE: 9,
  WAREHOUSING: 10
}

export default ({
  currentImage,
  setIsAnnotate,
  onPropIndex,
  onVisibleChange,
  onInit,
  onChange,
}) => {
  const {
    state,
    sampleClothingAuth,
    latestOperationUserId,
    processId, stepStatus, id, stepId, source, process, memberType } = currentImage

  const onUpdateSampleStatus = async (operation) => {
    if (operation === SAMPLE_OPERATION.MADE_PATTERN) {
      if (userInfo.userId !== latestOperationUserId) {
        message.error('非开始打版人员不能操作完成打版')
        return
      }
    }
    const res = await request.post('/zhikuan/mn/sample/update-sample-state', { operation, sampleId: id })
    if (res) {
      if (operation === SAMPLE_OPERATION.WAREHOUSING) {
        message.success('已成功入库该样衣')
      }
      onInit()
    }
  }

  const _onChange = (val) => {
    onInit()
    onChange(val)
  }
  return <div className={styles.infoBlockFooter}>
    {
      isPermissions(sampleClothingAuth, ['operateAndUpdateSample']) && processId > 0 ? <SampleDetailExamine
        stepId={stepId}
        stepStatus={stepStatus}
        setVisible={onVisibleChange}
        id={id}
        process={process}
        setIsAnnotate={setIsAnnotate}
        onUpdateSampleStatus={_onChange}
      />
        : <div className={styles['options-btn-wrap']} onClick={() => setIsAnnotate?.(false)}>
          {state === SAMPLE_STATE.UNMAKE_PATTERN ? <span className="status-edit-wrap">
            {source !== STYLE_PLAN.CAIMAI ? <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.BEGIN_PATTERN)} style={{ marginRight: 16 }}>开始打版</Button> : null}
            <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.PUECHASE_SAMPLE)}>采买样衣</Button>
          </span> : null}
          {(memberType === MEMBER_TYPE.SUPER_ADMIN || memberType === MEMBER_TYPE.ADMIN) || isPermissions(sampleClothingAuth, ['operateAndUpdateSample']) || userInfo.userId === latestOperationUserId ? <>
            {state === SAMPLE_STATE.MAKING_PATTERN ? <span className="status-edit-wrap">
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.MADE_PATTERN)} style={{ marginRight: 16 }}>完成打版</Button>
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.CANCEL_PATTERN)}>取消打版</Button>
            </span> : null}
            {state === SAMPLE_STATE.MADE_PATTERN ? <span className="status-edit-wrap">
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.BEGIN_SAMPLE)} style={{ marginRight: 16 }}>开始制样</Button>
            </span> : null}
            {state === SAMPLE_STATE.MAKING_SAMPLE ? <span className="status-edit-wrap">
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.MADE_SAMPLE)} style={{ marginRight: 16 }}>完成打样</Button>
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.CANCEL_SAMPLE)}>取消打样</Button>
            </span> : null}
            {state === SAMPLE_STATE.MADE_SAMPLE || state === SAMPLE_STATE.PURCHASED ? <span className="status-edit-wrap">
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.WAREHOUSING)} style={{ marginRight: 16 }}>入库样衣</Button>
            </span> : null}
            {state === SAMPLE_STATE.PURCHASING ? <span className="status-edit-wrap">
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.PURCHASED)} style={{ marginRight: 16 }}>完成采买</Button>
              <Button className="sample-operation-btn" onClick={() => onUpdateSampleStatus(SAMPLE_OPERATION.CANCEL_PURCHASE)}>取消采买</Button>
            </span> : null}</> : null}
          <Button
            type="primary"
            className="sample-edit-btn"
            onClick={() => {
              onPropIndex(0)
              onVisibleChange(true)
            }}
          >编辑样衣</Button>
        </div>
    }
  </div>
}
